import superagentPromise from 'superagent-promise'
import _superagent from 'superagent'
import mockedAgent from './mockedAgent'
import { Auth } from './Auth'
import { Admin } from './Admin'
import { Addons } from './Addons'
import { Domains } from './Domains'
import { Keywords } from './Keywords'
import { Region } from './Region'
import { Billing } from './Billing'
import { Users } from './Users'
import { Competitors } from './Competitors'
import { BacklinkChecker } from './BacklinkChecker'
import { Favourites } from './Favourites'
import { Reports } from './Reports'
import { SeoChecklist } from './SeoChecklist'
import { KeywordFinder } from './KeywordFinder'
import { SerpChecker } from './SerpChecker'
import { WebsiteAudit } from './WebsiteAudit'
import { Dashboard } from './Dashboard'
import { Message } from './Message'
import { Lists } from './Lists'
import { Tags } from './Tags'
import { Share } from './Share'
import { AppSocket } from './AppSocket'

const superagent = superagentPromise(_superagent, global.Promise)
export const mainApiRoot =
  process.env.REACT_APP_MAIN_API_ROOT || 'https://api-staging.ranktracker.com/v1'
export const regionApiRoot =
  process.env.REACT_APP_REGION_API_ROOT || 'https://region-search.herokuapp.com'
export const websocketRoot = process.env.REACT_APP_WEBSOCKET || 'ws://api.ranktracker.com/v1'
export const mock = process.env.REACT_APP_MOCK || 'https://api-staging.ranktracker.com/mocks'
export const staticRoot = process.env.REACT_APP_STATIC_ROOT || 'https://app-staging.ranktracker.com/data'

const responseBody = res => res.body
const responseFile = res => res.body

let token = null
const tokenPlugin = req => {
  if (token) {
    req.set('authorization', `Token ${token}`)
  }
}

export const requests = {
  del: (API, url, body) =>
    superagent
      .del(`${API}${url}`)
      .send(body)
      .use(tokenPlugin)
      .then(responseBody),
  get: (API, url) =>
    superagent
      .get(`${API}${url}`)
      .use(tokenPlugin)
      .then(responseBody),
  getFile: (API, url) =>
    superagent
      .get(`${API}${url}`)
      .responseType('blob')
      .use(tokenPlugin)
      .then(responseFile),
  put: (API, url, body) =>
    superagent
      .put(`${API}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody),
  post: (API, url, body) =>
    superagent
      .post(`${API}${url}`, body)
      .use(tokenPlugin)
      .then(responseBody)
}

const FileUpload = {
  preasignedUrl: body =>
    superagent
      .post(`${mainApiRoot}/presigned-url`, body)
      .set('Accept', 'application/json')
      .set('Content-Type', 'application/json')
      .use(tokenPlugin)
      .then(res => res),
  uploadFile: (url, headers, body) =>
    superagent
      .put(url, body)
      .set('Content-Disposition', headers['Content-Disposition'])
      .set('Content-MD5', headers['Content-MD5'])
      .set('Content-Type', headers['Content-Type'])
      .then(res => res)
}

const agent = {
  Auth,
  Admin,
  Addons,
  BacklinkChecker,
  Favourites,
  Domains,
  Keywords,
  Region,
  Billing,
  Users,
  Competitors,
  Reports,
  SeoChecklist,
  KeywordFinder,
  SerpChecker,
  WebsiteAudit,
  Dashboard,
  Message,
  Lists,
  Tags,
  Share,
  FileUpload,
  AppSocket,
  setToken: _token => {
    token = _token
  }
}

export const mocked = mockedAgent
export default agent
